import { Position, useReactFlow } from "reactflow";
import dagre from "dagre";

const Layout = () => {
  const { setNodes, setEdges, getEdges, getNode } = useReactFlow();

  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  const positionMap = {
    T: Position.Top,
    L: Position.Left,
    R: Position.Right,
    B: Position.Bottom,
  };

  // The layout direction (T = top, R = right, B = bottom, L = left, TB = top to bottom, ...)
  // 'TB' | 'LR' | 'RL' | 'BT'
  const updateLayout = async (selectedData, direction, isSelected = false) => {
    if (!direction || !selectedData.nodes.length) {
      return;
    }

    let minXPosition = Math.min(
      ...selectedData.nodes.map((item) => item.position.x)
    );
    let minYPosition = Math.min(
      ...selectedData.nodes.map((item) => item.position.y)
    );

    const nodes = selectedData.nodes.sort(
      (a, b) => a.position.y - b.position.y
    );

    const edges = selectedData.edges;

    const uniqueNodesValue = [];

    const uniqueNodes = edges
      .filter((edge, index, self) => {
        return (
          self.findIndex((e) => e.target === edge.target && e !== edge) === -1
        );
      })
      .reduce((acc, edge) => {
        acc[edge.source] = edge;
        return acc;
      }, {});

    const nodesIds = nodes.map((node) => node.id);
    const edgesIds = edges.map((edge) => edge.id);

    dagreGraph.setGraph({
      rankdir: direction,
      marginx: minXPosition - 115,
      marginy: minYPosition - 70,
    });

    await nodes.forEach((node) => {
      dagreGraph.setNode(node.id, {
        width: node.width,
        height: node.height,
      });
    });

    await edges.forEach((edge) => {
      dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    if (nodesIds.length) {
      setNodes((nodes) =>
        nodes.map((node) => {
          if (nodesIds.includes(node.id)) {
            let { x, y } = dagreGraph.node(node.id);
            let xPosition = x;
            let yPosition = y;

            let nodeValue = {
              ...node,
              selected: isSelected,
              sourcePosition: positionMap[direction[1]],
              targetPosition: positionMap[direction[0]],
              position: { x: xPosition, y: yPosition },
              style: { opacity: 1 },
            };

            // Change x,y for the `whatIfNode`
            if (node.type == "whatIfNode") {
              const parentEdge = selectedData.edges.find(
                (edge) => edge.target == node.id
              );
              let { x, y } = dagreGraph.node(parentEdge.source);
              nodeValue.position.xPosition = x;
              nodeValue.position.yPosition = y + node.height + 100;
            }

            // Change x,y for the single connected node
            // if (uniqueNodes[node.id] && node.type !== "whatIfNode") {
            //   const edgeVal = uniqueNodes[node.id];
            //   nodeValue.position.yPosition = y + yOffset(node, edgeVal);
            // }

            // const getParentEdge = getEdges().find(
            //   (edge) => edge.source === node.id
            // );

            // if (
            //   getParentEdge &&
            //   Object.keys(uniqueNodes).includes(getParentEdge.target)
            // ) {
            //   const getCurrentEdge = getEdges().find(
            //     (edge) => edge.source === node.id
            //   );

            //   console.log("getCurrentEdge => ", getCurrentEdge);
            //   nodeValue.position.yPosition = yOffset(node, getCurrentEdge);
            // }

            return {
              ...node,
              selected: isSelected,
              sourcePosition: positionMap[direction[1]],
              targetPosition: positionMap[direction[0]],
              position: { x: xPosition, y: yPosition },
              style: { opacity: 1 },
            };
          } else {
            return node;
          }
        })
      );
    }

    if (edgesIds.length) {
      setEdges((edges) =>
        edges.map((edge) => {
          if (edgesIds.includes(edge.id)) {
            return { ...edge, style: { opacity: 1 } };
          } else {
            return edge;
          }
        })
      );
    }
  };

  return {
    updateLayout,
  };
};

const yOffset = (node, edgeVal) => {
  return edgeVal.targetHandle === "target-a"
    ? -node.height * 0.7
    : node.height * 0.7;
};

export default Layout;
